import React from "react";
import SummaryPageLayoutContainer from "ui/medrefill/components/common/SummaryPageLayout/SummaryPageLayoutContainer";

const TopupOrderSummaryPage = () => {
  return <SummaryPageLayoutContainer></SummaryPageLayoutContainer>;
};

export default TopupOrderSummaryPage;
